export default "__VITE_ASSET__B3aHT7Vc__"